export default [
  {
    name: "商业协议",
    href: "https://license.bladex.cn"
  },
  {
    name: "授权须知",
    path: "/notice"
  }, {
    name: '软著证书',
    path: '/biz-cert'
  }, {
    name: '功能对比',
    path: '/compare'
  }, {
    name: "开源版",
    groups: [{
      list: [{
        title: "更新日志",
        path: "/changelog"
      }, {
        title: '项目简介',
        path: '/introduction'
      }, {
        title: '功能清单',
        path: '/list'
      }, {
        title: '环境要求',
        path: '/requirement'
      }, {
        title: '开发手册',
        path: '/docs'
      }]
    }]
  }, {
    name: "商业版",
    groups: [{
      list: [{
        title: "更新日志",
        path: "/biz-changelog"
      }, {
        title: '项目简介',
        path: '/biz-introduction'
      }, {
        title: '授权说明',
        path: '/biz-license'
      }, {
        title: '开发计划',
        path: '/biz-plan'
      }, {
        title: '功能清单',
        path: '/biz-list'
      }]
    }]
  }
]
